export default __webpack_public_path__ + "static/media/homepagelogos.fdbf57f6.png";